import { ChangeDetectionStrategy, Component, HostBinding, ViewEncapsulation } from "@angular/core";

@Component({
	selector: "obg-empty-layout",
	templateUrl: "./empty-layout.component.html",
	styleUrls: ["./empty-layout.component.scss"],
	changeDetection: ChangeDetectionStrategy.OnPush,
	encapsulation: ViewEncapsulation.None,
})
export class EmptyLayoutComponent {
	@HostBinding("class.obg-empty-layout") hostCssClass = true;
}
